import { NextPageContext } from 'next';
import { Page } from 'locales/types/components';
import { string } from 'yup';

import ApiJob from 'types/api/Job';
import { Locales } from 'types/locale';
import ListCollection from 'types/redux/ListCollection';

import Article from 'models/Article';
import City from 'models/City';
import CmsPage from 'models/CmsPage';
import Job from 'models/Job';
import JobAgreement from 'models/JobAgreement';
import JobCategory from 'models/JobCategory';
import JobExperience from 'models/JobExperience';
import JobLanguage from 'models/JobLanguage';
import JobMode from 'models/JobMode';
import JobTime from 'models/JobTime';
import User from 'models/User';

import { Props as SectionArticlesProps } from './sections/Articles/types';
import { Props as SectionFiltersProps } from './sections/Filters/types';
import { Props as SectionListProps } from './sections/List/types';
import { Props as SectionNewsletterProps } from './sections/Newsletter/types';
import { Props as SectionSaveProps } from './sections/Save/types';
import { Props as SectionSearchProps } from './sections/Search/types';
import { Props as SectionTutorialsProps } from './sections/Tutorials/types';


export enum FitlersSort {
	Relevant = 'relevance',
	Newest = 'newest',
	Last3Days = '3',
	Last7Days = '7',
	Salary = 'salaryTo',
}

export interface Filters {
	jobCompanyCitySlug?: string;
	districtSlug?: string;
	sort?: FitlersSort;
}


export interface IInitialResources {
	articles: Article[],
	jobs: ListCollection<Job>,
	jobModes: JobMode[],
	jobCategories: JobCategory[],
	jobAgreements: JobAgreement[],
	jobExperiences: JobExperience[],
	jobLanguages: JobLanguage[],
	jobTimes: JobTime[],
	jobCities: City[],
	initialCity: City,
}


export interface Props extends ParentProps {
	state?: {
		user: User;
	};
	cmsPage?: CmsPage;
}

export interface ParentProps {
	lang?: Locales;
	data?: Page<PageContent>;
	initialResources: IInitialResources,
	initialSearchParams: any,
	notFound?: boolean;
	query?: any
}

export interface PageContent {
	search: SectionSearchProps;
	filters: SectionFiltersProps;
	jobs: ApiJob[];
	articles: SectionArticlesProps;
	tutorials: SectionTutorialsProps;
	save: SectionSaveProps;
	newsletter: SectionNewsletterProps;
	list: SectionListProps;
	listProps: {
		saveBtn: string;
		roadBtn: string;
	};
}

export interface NextPageContextCustom extends NextPageContext {
	lang: Locales;
}

